import { useMemo } from 'react';
import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type SwrKey, type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/products/{productId}/team-member-availability']['GET'];
type Params = ThisApi['params'];
type Output = ThisApi['response'];

/** SWR hook for fetching team members with availability for a product. */
export const useTeamMembersWithAvailability = (
  params: Params | null,
  config?: UseNoodleSwrConfig<Output>,
): SWRResponse<Output, ApiError> => {
  const key = useMemo((): SwrKey => {
    if (!params?.productId) return null;
    return `/products/${params.productId}/team-member-availability`;
  }, [params?.productId]);

  return useNoodleSwr<Output>(key, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated Please use `useTeamMembersWithAvailability` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getTeamMembersWithAvailability = async ({ productId }: Params): Promise<Output> => {
  const response = await noodleApiClient.get(`/products/${productId}/team-member-availability`);
  return response.data;
};

export default getTeamMembersWithAvailability;
